import { convertToNumber } from 'src/features/AddEditPersonAlert/utils/personStoreHelper';

import { formatToUtcWithOffset } from 'src/utils/datepickerHelper';
import {
  form1AccountId,
  form2AccountId,
  form3AccountId,
} from './activityTrackerConstants';

import { TReturnType } from '../types/scheduleCallType';

//get the formname
function getFormName(accountId: number | undefined) {
  if (accountId === parseInt(form1AccountId)) {
    return 'Adolescent Acute Care Clinical Placement';
  } else if (accountId === parseInt(form2AccountId)) {
    return 'Hospital Followup';
  } else if (accountId === parseInt(form3AccountId)) {
    return 'Youthline Follow-up Form';
  } else 'All';
}

//class name for badge
function varientName(status: string | undefined) {
  switch (status) {
    case 'Cancelled':
      return 'danger';
    case 'Completed':
      return 'success';
    case 'Scheduled':
      return 'warning';
    case 'Pending':
      return 'info';
  }
}

function validationMsg(value: any, key: string) {
  if (
    value?.hasOwnProperty(key) &&
    value[key] !== '' &&
    value[key] !== '-1' &&
    value[key] !== null
  ) {
    return true;
  } else if (key === 'caseId') {
    if (
      value?.linkExistingCase === true &&
      (value?.caseId === undefined || value?.caseId === '')
    ) {
      return false;
    }
    return true;
  } else return false;
}

//for formatting scheduleCall
function formatScheduleCall(
  schedulerCallDetails: any,
  clinicianList: TReturnType,
  personRepoValues: any,
) {
  const dateValue = formatToUtcWithOffset(schedulerCallDetails?.scheduledTime);
  const formattedvalue = {
    AdditionalInfo: schedulerCallDetails?.additionalInfo
      ? schedulerCallDetails?.additionalInfo
      : '',
    AssignToAnyone: schedulerCallDetails?.assignedToAnyone
      ? schedulerCallDetails?.assignedToAnyone
      : false,
    AssignedGroupId:
      schedulerCallDetails?.AssignedGroupId &&
      schedulerCallDetails?.assignedToAnyone === true &&
      schedulerCallDetails?.AssignedGroupId !== '-1'
        ? convertToNumber(schedulerCallDetails?.AssignedGroupId)
        : null,
    AssignedTo: formatAssignedToParam(schedulerCallDetails, clinicianList),
    AttemptsToContact: schedulerCallDetails?.attempts
      ? schedulerCallDetails?.attempts
      : '',
    CallId: null,
    CallsCount: null,
    CancelNote: '',
    CaseId: schedulerCallDetails?.caseId ? schedulerCallDetails?.caseId : null,
    EndDate: dateValue && dateValue[1],
    FormId: schedulerCallDetails?.Id ? schedulerCallDetails?.Id : '',
    Id: 0,
    IsChecked: false,
    ModeOfCreation: 'Hospital Form',
    Person: formattedPerson(schedulerCallDetails, personRepoValues),
    PersonId: schedulerCallDetails?.Id,
    PhoneNumber: schedulerCallDetails?.phoneNumber
      ? schedulerCallDetails?.phoneNumber
      : null,
    PreferredPhone: 'Primary',
    StartDate: dateValue && dateValue[0],
    Status: 'Pending',
    SupervisorsEmail: formatSupervisorsName(schedulerCallDetails),
    TimeInterval: schedulerCallDetails?.scheduledTime,
    TimeZoneId: schedulerCallDetails?.timezone
      ? convertToNumber(schedulerCallDetails?.timezone)
      : null,
  };

  return formattedvalue;
}
function formattedPerson(schedulerCallDetails: any, personRepoValues: any) {
  const val = {
    ...schedulerCallDetails,
    EntityId:
      Object.keys(personRepoValues)?.length === 0
        ? schedulerCallDetails?.EntityId
        : personRepoValues?.EntityId,
    Account: null,
    PrimaryPhone: {
      ...schedulerCallDetails?.PersonOfConcern?.PrimaryPhone,
      PhoneType: { ...schedulerCallDetails?.PrimaryPhone?.PhoneType },
      OkToLeaveMessage:
        schedulerCallDetails?.leaveMessage === 1 ||
        schedulerCallDetails?.leaveMessage === '1'
          ? true
          : schedulerCallDetails?.leaveMessage === '2' ||
            schedulerCallDetails?.leaveMessage === 2
          ? false
          : undefined,
      Comments: schedulerCallDetails?.comments,
      CountryId: schedulerCallDetails?.countryId ?? 1,
      Number: schedulerCallDetails?.phoneNumber,
    },
  };

  const keysToRemove = [
    'comments',
    'countryId',
    'fromHF',
    'leaveMessage',
    'phoneNumber',
    'phoneType',
    'scheduledTime',
    'timezone',
  ];

  const newObj = Object.fromEntries(
    Object.entries(val).filter(([key]) => !keysToRemove.includes(key)),
  );

  return newObj;
}
function formatAssignedToParam(
  schedulerCallDetails: any,
  clinicianList: TReturnType,
) {
  const value =
    (schedulerCallDetails?.AssignedTo &&
      schedulerCallDetails?.assignedToAnyone === false) ||
    !schedulerCallDetails.hasOwnProperty('assignedToAnyone')
      ? clinicianList?.find(
          (item: any) =>
            item?.value?.toString() === schedulerCallDetails?.AssignedTo,
        )?.label
      : '';
  return value;
}
function formatSupervisorsName(schedulerCallDetails: any) {
  const value = schedulerCallDetails?.calltaker
    ? schedulerCallDetails?.calltaker?.map(
        (item: { value: number; label: string }) => {
          return item?.label;
        },
      )
    : [];
  return value;
}

function getNestedValue(obj: any, path: string): any {
  return path.split('.').reduce((acc, part) => acc?.[part], obj);
}

function setNestedValue(obj: any, path: string, value: any): void {
  const parts = path.split('.');
  const last = parts.pop()!;
  const target = parts.reduce((acc, part) => {
    if (!acc[part]) acc[part] = {};
    return acc[part];
  }, obj);
  target[last] = value;
}

const flattenObject = (
  obj: Record<string, any>,
  parentKey = '',
  result: Record<string, any> = {},
): Record<string, any> => {
  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
    const value = obj[key];
    const newKey = parentKey ? `${parentKey}.${key}` : key;

    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      flattenObject(value, newKey, result);
    } else if (value === null && typeof value !== 'object') {
      result[newKey] = null;
    } else if (value === null) {
      // explicitly mark null objects so their children show as undefined
      result[newKey] = null;
    } else {
      result[newKey] = value;
    }
  }

  return result;
};

function deepSet(obj: any, path: string, value: any): void {
  const keys = path.split('.');
  let current = obj;

  keys.forEach((key, index) => {
    if (index === keys.length - 1) {
      current[key] = value;
    } else {
      if (typeof current[key] !== 'object' || current[key] === null) {
        current[key] = {};
      }
      current = current[key];
    }
  });
}

const setDeepValue = (obj: any, path: string, value: any) => {
  const keys = path.split('.');
  const lastKey = keys.pop()!;
  const deepRef = keys.reduce((acc, key) => {
    if (!acc[key]) acc[key] = {};
    return acc[key];
  }, obj);
  deepRef[lastKey] = value;
};

export {
  getFormName,
  varientName,
  formatScheduleCall,
  validationMsg,
  setNestedValue,
  flattenObject,
  deepSet,
  setDeepValue,
};
